<template>
  <ContactReviewDisplayComponent
    :accountData="accountData"
    :accountRules="accountRules"
    :companyRules="companyRules"
    :companyIndex="companyIndex"
    :enableCompanySearch="true"
    :countryCode="countryCode"
    @updateAccountData="$emit('updateAccountData', $event)"
    @handleUpdateCompany="$emit('handleUpdateCompany', $event)"
    @selectExistingCompany="$emit('selectExistingCompany', $event)"
    @resetCompanySelection="$emit('resetCompanySelection')"
  >
    <template #account="{ phoneCountryCode, accountField }">
      <TextRowComponent v-bind="accountField('name')" />
      <TextRowComponent
        v-bind="accountField('phone_number')"
        type="tel"
        :countryCode="phoneCountryCode"
      />
    </template>
    <template #company="{ locked, companyField }">
      <TextRowComponent v-bind="companyField('name')" :disabled="locked" />
      <TextRowComponent
        v-bind="companyField('registry_code')"
        :disabled="locked"
      />
      <TextRowComponent v-bind="companyField('address')" :disabled="locked" />
      <TextRowComponent v-bind="companyField('vat')" :disabled="locked" />
    </template>
  </ContactReviewDisplayComponent>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import type { Account, Company } from "@/types";
import { useContactReviewValidation } from "@/composables/useContactReviewValidation";
import { useI18n } from "vue-i18n";
import TextRowComponent from "@/signup/common/TextRowComponent.vue";
import ContactReviewDisplayComponent from "@/signup/ContactReviewDisplayComponent.vue";
import { useSignupStore } from "@/signup/signup";

defineProps<{
  accountData: Account;
  companyIndex?: number;
}>();

defineEmits<{
  updateAccountData: [accountData: Account];
  handleUpdateCompany: [company: Company];
  selectExistingCompany: [companyId: number];
  resetCompanySelection: [];
}>();

const { t } = useI18n();
const { accountRules, companyRules } = useContactReviewValidation(t);
const { country: countryCode } = storeToRefs(useSignupStore());
</script>
